// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__rFUcr","noInteraction":"EventWrapper_noInteraction__xF8pE","pointerPassthrough":"EventWrapper_pointerPassthrough__1USVc"};